/* eslint-disable max-len */
export const RP_LOGO_URL = 'https://zpckit.s3.amazonaws.com/uploads/2019/10/LK_valkoinen_rgb.jpg';
export const LOGO_URL = 'https://zpckit.s3.amazonaws.com/uploads/2019/11/zeckit_logo.png';
export const LOGO_SMALL_URL = 'https://zpckit.s3.amazonaws.com/uploads/2019/11/zeckit_logo_small.png';
/* eslint-enable max-len */

export const DEV_HOSTNAMES = ['dev.zeckit.com', 'staging.zeckit.com'];
export const LOCAL_HOSTNAMES = ['0.0.0.0', 'localhost'];

export const LOCAL_CLIENT_PORT = 3000;

export function isNarrowLayout() {
  return !!window.matchMedia('screen and (max-width: 34em)').matches;
}

export function toTitleCase(str) {
  // \S -> any non-space character
  return str.replace(
    /\S+/g,
    txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
}

export function getToken() {
  const matches = /[^A-Za-z0-9]token=([0-9a-z]+)/.exec(window.location.hash);
  if (!matches || !matches[1]) return null;
  return matches[1];
}

export function buildQueryString(params) {
  return Object.keys(params)
    .filter(k => params[k] !== undefined)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
}

export function getClientUrl() {
  return window.location.origin;
}

export function getApiUrl() {
  return `${getClientUrl()}/api`;
}

export function getStatementUrl(countryCode, businessId, locale = 'fi') {
  const statementUrl = `${getClientUrl()}/selvitys`;
  return `${statementUrl}/${countryCode}/${businessId}?lang=${locale}`;
}

export function getBrochureUrl(countryCode, businessId, locale = 'fi') {
  const brochureUrl = `${getClientUrl()}/selvitys/esite`;
  return `${brochureUrl}/${countryCode}/${businessId}?lang=${locale}`;
}

export function getBadgeImageUrl(countryCode, businessId, lk) {
  return `${getApiUrl()}` +
    `/widget/badge/${countryCode}/${businessId}.png` +
    `?lk=${lk ? 1 : 0}&negative_reviews=${false}`;
}

export function getImageUrl(imageId, css=true) {
  if (css) {
    return imageId ? `url("${getApiUrl()}/images/${imageId}")` : 'none';
  }
  return imageId ? `${getApiUrl()}/images/${imageId}` : '';
}

export function getThumbnailUrl(imageId, css=true) {
  if (css) {
    return imageId
      ? `url("${getApiUrl()}/images/${imageId}/thumbnail")`
      : 'none';
  }
  return imageId ? `${getApiUrl()}/images/${imageId}/thumbnail` : '';
}

export function getZeckitLoginUrl() {
  const { hostname, protocol } = window.location;
  const currentURL = encodeURIComponent(document.location.href);
  let OAuthUrl = process.env.ZECKIT_OAUTH;
  if (DEV_HOSTNAMES.indexOf(hostname) !== -1) {
    OAuthUrl = `${protocol}//${hostname}`;
  } else if (LOCAL_HOSTNAMES.indexOf(hostname) !== -1) {
    OAuthUrl = `https://${DEV_HOSTNAMES[0]}`;
  }
  return `${OAuthUrl}/oauth/authorize/?client_id=` +
    `${process.env.ZECKIT_OAUTH_CLIENT_ID}&redirect_uri=${currentURL}` +
    '&response_type=token';
}

export function getCompanyDashboardPath(countryCode, businessId) {
  return `/selvitys/${countryCode}/${businessId}/dashboard`;
}
